<template>
  <div class="action-card">
    <div class="action-card__image" v-if="image">
      <img :src="image" />
    </div>
    <div class="action-card__text">
      <p>{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionCard',
  props: {
    image: String,
    text: String,
  },
};
</script>

<style lang="scss">
.action-card {
  padding: 20px;
  box-sizing: border-box;
  border-radius: 3px;
  &__image {
    text-align: center;
    img {
      width: 100%;
    }
  }
  &__text {
    font-size: 14px;
    color: #a5acbc;
    line-height: 18px;
    text-align: center;
  }
}
</style>
